import React from 'react';
import { useNavigate } from 'react-router-dom'; // Using useNavigate for navigation
import Navbar from '../components/Navbar'; // Adjust the path as needed
import '../styles/CAD.css';

const AIAndMLConsulting = () => {
    const navigate = useNavigate();

    // For demonstration, the Learn More buttons currently redirect to Google.
    // Replace with your actual navigation logic or paths as needed.
    const handleNavigation = () => {
        navigate('/contact');
    };

    return (
        <>
            <Navbar />
            <div className="custom-app-development">
                <div className="content-box">
                    <header className="header">
                        <h1>AI & ML Consulting</h1>
                        <p className="tagline">
                            Harness the transformative power of AI and ML with our expert consulting.
                        </p>
                    </header>

                    <section className="introduction">
                        <p>
                            Embrace the future with our AI & ML Consulting services. We empower your organization to transform raw data into actionable insights using cutting-edge artificial intelligence and machine learning techniques. From strategy formulation to model deployment, our team works closely with you to drive innovation and achieve competitive advantage.
                        </p>
                    </section>

                    <section className="why-choose-us">
                        <h2>Want tailored AI solutions for your business?</h2>
                        <p>
                            Our expert consultants provide end-to-end support—identifying key opportunities, developing custom models, and integrating AI solutions into your business processes. We ensure your AI initiatives are ethical, secure, and scalable, enabling data-driven decision-making across your organization.
                        </p>
                    </section>

                    <section className="tech-stack">
                        <h2>Our AI & ML Approach</h2>
                        <p>
                            We leverage industry-leading frameworks and methodologies to deliver tailored AI solutions:
                        </p>
                        <ul>
                            <li><strong>Data Analytics & Preparation:</strong> Comprehensive data assessment and cleaning to build high-quality models.</li>
                            <li><strong>Custom Model Development:</strong> Creating predictive, classification, and recommendation models using TensorFlow, PyTorch, and Scikit-learn.</li>
                            <li><strong>Integration & Deployment:</strong> Seamless incorporation of AI solutions into your existing systems with robust monitoring.</li>
                            <li><strong>Continuous Optimization:</strong> Iterative model tuning and performance monitoring to ensure lasting impact.</li>
                        </ul>
                    </section>

                    <section className="secure-practices">
                        <h2>Ethical & Secure AI Solutions</h2>
                        <p>
                            We adhere to best practices in data privacy, bias mitigation, and transparency. Our processes include rigorous audits and compliance checks to ensure that your AI implementations are secure, responsible, and aligned with industry standards.
                        </p>
                    </section>

                    <section className="services">
                        <h2>Our AI & ML Consulting Services</h2>
                        <div className="service-container">
                            <div className="service-box">
                                <h3>Strategy & Roadmap</h3>
                                <p>
                                    Develop a comprehensive AI strategy that aligns with your business objectives and growth targets.
                                </p>
                                <button className="learn-more" onClick={handleNavigation}>
                                    Learn More
                                </button>
                            </div>
                            <div className="service-box">
                                <h3>Data Analytics</h3>
                                <p>
                                    Unlock valuable insights from your data through advanced analytics and machine learning techniques.
                                </p>
                                <button className="learn-more" onClick={handleNavigation}>
                                    Learn More
                                </button>
                            </div>
                            <div className="service-box">
                                <h3>Custom Model Development</h3>
                                <p>
                                    Build bespoke AI models tailored to solve your unique business challenges.
                                </p>
                                <button className="learn-more" onClick={handleNavigation}>
                                    Learn More
                                </button>
                            </div>
                            <div className="service-box">
                                <h3>Integration & Support</h3>
                                <p>
                                    Seamlessly integrate AI solutions into your workflow and receive ongoing support to drive success.
                                </p>
                                <button className="learn-more" onClick={handleNavigation}>
                                    Learn More
                                </button>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </>
    );
};

export default AIAndMLConsulting;
